export default __webpack_public_path__ + "static/find-your-zen-61464f95185d189a7e605fed64b12db8.gif";